import React from 'react';
import { emailDeliveryNotice } from '../../productNotices';

export function Icon({ name, size = 20, ...props }) {
  const paths = {
    plus: <path d="M12 5v14M5 12h14" />,
    arrow: <path d="M4 12h16m-6-6 6 6-6 6" />,
    external: <><path d="M14 4h6v6M20 4 10 14" /><path d="M10 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5" /></>,
    clock: <><circle cx="12" cy="12" r="8" /><path d="M12 7v5l3 2" /></>,
    check: <path d="m5 12 4 4L19 6" />,
    alert: <><path d="m12 3 10 18H2L12 3Z" /><path d="M12 9v4m0 3v.1" /></>,
    refresh: <><path d="M20 7v5h-5M4 17v-5h5" /><path d="M6 6a8 8 0 0 1 13 3M5 15a8 8 0 0 0 13 3" /></>,
    search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 4 4" /></>,
    sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" /></>,
    moon: <path d="M20.5 13A9 9 0 0 1 11 3.5 9 9 0 1 0 20.5 13Z" />,
    menu: <path d="M4 6h16M4 12h16M4 18h16" />,
    close: <path d="m6 6 12 12M6 18 18 6" />,
    tent: <><path d="m3 20 9-16 9 16H3Zm5 0 4-7 4 7M9 3l3 4 3-4" /></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name] || paths.tent}</svg>;
}

// An explicit beta notice, not a live service-health response. The current API
// exposes account preferences but not the global delivery gate. Keep this copy
// in sync with an owner-approved delivery change until that contract exists.
export function DeliveryNotice({ compact = false }) {
  if (emailDeliveryNotice.mode === 'none') return null;
  return <aside className={`delivery-notice ${compact ? 'delivery-notice--compact' : ''}`} aria-label="Email delivery notice">
    <Icon name="clock" />
    <div><strong>{emailDeliveryNotice.heading}</strong>{' '}
      <span>{compact ? emailDeliveryNotice.compactDescription : emailDeliveryNotice.description}</span>
    </div>
  </aside>;
}

export function formatFrequency(value) {
  return { daily: 'Daily', hourly: 'Hourly', '15min': 'Every 15 minutes' }[value] || 'Not available';
}

export function getAllowance(profile) {
  return Number.isInteger(profile?.max_usernames) && profile.max_usernames >= 0 ? profile.max_usernames : null;
}
